
import CardPropertyString from '../../components/Card/CardPropertyString.vue'
import { convertIntervalToYYMMDD } from '../../components/helpers.js'

export default {
  extends: CardPropertyString,
  watch: {
    object: {
      handler: function () {
        this.setWorkExperience()
      },
      immediate: true
    },
    'object.employmentDate': {
      handler: function () {
        this.setWorkExperience()
      }
    },
    'object.commonWorkExperience': {
      handler: function () {
        this.setWorkExperience()
      }
    },
    'object.workExperienceStartDate': {
      handler: function () {
        this.setWorkExperience()
      }
    },
    'object.resignationDate': {
      handler: function () {
        this.setWorkExperience()
      }
    },
    'object.state': {
      handler: function () {
        this.setWorkExperience()
      }
    }
  },
  methods: {
    setWorkExperience: function () {
      let employmentDate = this.object.employmentDate
      if (this.object.commonWorkExperience && this.object.workExperienceStartDate) {
        employmentDate = this.object.workExperienceStartDate
      }

      let fromDate = new Date().getTime()
      if (this.object.state === 'dismissed' && this.object.resignationDate) {
        fromDate = this.object.resignationDate
      }

      this.object[this.tabProp.key] = convertIntervalToYYMMDD(employmentDate, fromDate)
    }
  }
}
